export default __webpack_public_path__ + "static/media/ring1.a93f0bdc.png";